import React, {useContext, useEffect, useState} from 'react';
import { useNavigate} from "react-router-dom";

import {PAContext} from "../../../Services/PAContext";
import {
    Avatar,
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip, Dialog,
    DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, ListSubheader,
    Menu,
    MenuItem,
    Paper, TextField, Tooltip
} from "@mui/material";
import Grid from '@mui/material/Grid';
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import "./attendees.css";
import sample_attendees from "../../../sampleData/Attendees";
import Box from "@mui/material/Box";
import attendeesHeaderImage from '../../../graphics/Backpackers-2.jpg';
import IconButton from "@mui/material/IconButton";
import {stringAvatar, stringToColor} from "../../Helpers/TextStyling";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import InfoAttendees from "../../Dialogs/InfoAttendees";
import PersonalBudget from "../../Dialogs/PersonalBudget";
import dayjs from "dayjs";
import CalendarExportDialog from "../../Dialogs/CalendarExport";
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";
import AttendeesAddDialog from "./AttendeesAddDialog";


function AttendeesList(props) {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [eventHasDates, setEventHasDates] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);

    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);

    const [sortedAttendees, setSortedAttendees] = useState([]);

    useEffect(() => {

        // 1. Map and Enrich
        const enrichedAttendees = PA_GlobalObject.Planning.attendees
            .map(att => {
                const ref = attendeesReferenceArray.find(r => r.id === att.id);

                return {
                    ...att,
                    role: (att.role || '').trim().toLowerCase(),
                    lname: (att.lname || '').trim(),
                    fname: (att.fname || '').trim(),
                    // 🔥 THE FIX: Prioritize the existing avatar on the attendee object,
                    // then fallback to the reference array, then null.
                    avatar: (typeof att.avatar === 'string' && att.avatar.length > 0)
                        ? att.avatar
                        : (ref?.avatar || null)
                };
            })
            .filter(Boolean)
            .sort((a, b) => {
                const roleOrder = { master_admin: 0, admin: 0, attendee: 1, guest: 1, partial: 1, planner: 2 };
                const roleA = roleOrder[a.role] ?? 1;
                const roleB = roleOrder[b.role] ?? 1;

                if (roleA !== roleB) return roleA - roleB;
                return a.lname.localeCompare(b.lname);
            });

        setSortedAttendees(enrichedAttendees);

    }, [attendeesReferenceArray, PA_GlobalObject.Planning.attendees]);


    /*
        this is for the Menu list in the header
     */
    const [isAttendeeInfoDialogOpen, setAttendeeInfoDialogOpen] = useState(false);

    const [anchorAttendeeListMenu, setAnchorAttendeeListMenu] = useState(null);
    const handleAttendeeListMenuOpenMenu = (event) => {
        setAnchorAttendeeListMenu(event.currentTarget);
    };
    const handleAttendeeListMenuClick = (event) => {
        const target = event.currentTarget;
        const dataId = target.getAttribute('data-id');

        handleAttendeeListMenuClose();

        if (dataId === "from-previous"){
            navigate('/Planner/Attendees/AddPrevious');
        } else if (dataId === "new-entry"){
            navigate('/Planner/Attendees/AddNew');
        } else if (dataId === "sample-attendees"){
            navigate('/Planner/Attendees/AddSamples');
        } else if (dataId === "attendees-dialog"){
            setAddAttendeesDialogOpen(true);
        }
    };
    const handleAttendeeListMenuClose = () => {
        setAnchorAttendeeListMenu(null);
    };


    const [isAddAttendeesDialogOpen, setAddAttendeesDialogOpen] = useState(false);


    /*
        this is for the Menu list for each individual Card
     */
    const [anchorAttendeeElements, setAnchorAttendeeElements] = useState([]);
    const handleOpenAttendeeMenu = (event, index) => {
        const updatedAnchors = [...anchorAttendeeElements];
        updatedAnchors[index] = event.currentTarget;
        setAnchorAttendeeElements(updatedAnchors);
    };

    // Function to handle closing the menu for a specific attendee.
    const handleCloseAttendeeMenu = (index) => {
        const updatedAnchors = [...anchorAttendeeElements];
        updatedAnchors[index] = null;
        setAnchorAttendeeElements(updatedAnchors);
    };

    function handleDialogEditOpen(attendee_id){
        props.setEditAttendeeId(attendee_id);
        navigate('/Planner/Attendees/Edit');
    }

    const [openDialogEventAdmin, setOpenDialogEventAdmin] = useState(false);
    const [attendeeToRemovePlannerStatusName, setAttendeeToRemovePlannerStatusName] = useState("");
    function handleDialogEventAdminClose() {
        setOpenDialogEventAdmin(false);
    }

    const handleUpdateAttendeeRole = (index, attendee_id, newRole) => {
        const normalizedRole = newRole.toLowerCase();
        const { attendees } = PA_GlobalObject.Planning;

        // 1. Update the Attendees Array (preserving avatars & fixing {} bug)
        const updatedAttendees = attendees.map((att) => {
            if (att.id === attendee_id) {
                // Re-fetch reference just in case current is an empty object
                const ref = attendeesReferenceArray.find(r => r.id === att.id);
                const validAvatar = (typeof att.avatar === 'string' && att.avatar.length > 0)
                    ? att.avatar
                    : (ref?.avatar || null);

                return {
                    ...att,
                    avatar: validAvatar,
                    role: normalizedRole,
                    planner: normalizedRole === 'planner'
                };
            }
            return att;
        });

        // 2. Re-derive the Host List (Automatic sync: Admin & Master Admin are hosts)
        const updatedHost = updatedAttendees
            .filter((att) => att.role === 'admin' || att.role === 'master_admin')
            .map((att) => att.id);

        // 3. Update the SCREEN (Instant Sort)
        const sorted = [...updatedAttendees].sort((a, b) => {
            const roleOrder = { master_admin: 0, admin: 0, attendee: 1, guest: 1, partial: 1, planner: 2 };
            const diff = (roleOrder[a.role] ?? 1) - (roleOrder[b.role] ?? 1);
            return diff !== 0 ? diff : (a.lname || '').localeCompare(b.lname || '');
        });
        setSortedAttendees(sorted);

        // 4. Update the GLOBAL STORE
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning,
                attendees: updatedAttendees,
                host: updatedHost
            },
        }));

        // 5. SERVER UPDATE
        if (PA_GlobalObject.Planning.status !== 10) {
            sendSocketMessage({
                action: "E_updateAttendeePrivilege",
                event_id: PA_GlobalObject.Planning.id,
                attendee_id: attendee_id,
                role: normalizedRole,
                name: ""
            });
        }

        handleCloseAttendeeMenu(index);
    };

    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [attendeeToDeleteId, setAttendeeToDeleteId] = useState("");
    const [attendeeToDeleteName, setAttendeeToDeleteName] = useState("");

    function handleDialogDeleteOpen(index, attendee_id) {
        console.log("handleDialogDeleteOpen : "+attendee_id);

        handleCloseAttendeeMenu(index);

        setAttendeeToDeleteId(attendee_id);

        const foundAttendee = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees.find((_att) => _att.id === attendee_id);
        setAttendeeToDeleteName(foundAttendee.fname + ' ' + foundAttendee.lname);

        setOpenDialogDelete(true);

    }
    function handleDialogDeleteClose() {
        setOpenDialogDelete(false);
    }
    function handleDialogDeleteOK(){
        setOpenDialogDelete(false);

        const indexToDelete = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees.findIndex((attendee) => attendee.id === attendeeToDeleteId);

        if (indexToDelete !== -1) {
            usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees.splice(indexToDelete, 1);
        }

        //this forces the features count to update
        navigate('/Planner/Attendees');

        setSortedAttendees([...usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees].sort((attendeeA, attendeeB) => {
            const lnameA = attendeeA.lname.toLowerCase();
            const lnameB = attendeeB.lname.toLowerCase();

            // Compare the lname values
            if (lnameA < lnameB) return -1;
            if (lnameA > lnameB) return 1;
            return 0;
        }));
    }

    const [openDialogRSVP, setOpenDialogRSVP] = useState(false);
    const [attendeeToRSVPId, setAttendeeToRSVPId] = useState("");
    function handleDialogRSVPOpen(attendee_id) {
        console.log("handleDialogRSVPOpen : "+attendee_id);

        setAttendeeToRSVPId(attendee_id);
        setOpenDialogRSVP(true);
    }
    function handleDialogRSVPClose() {
        setOpenDialogRSVP(false);
    }
    function handleDialogRSVPOK(status) {

        console.log("handleDialogRSVPOK : "+attendeeToRSVPId+" : "+status);

        setOpenDialogRSVP(false);

        // 🔁 Immutably update RSVP status
        const updatedAttendees = sortedAttendees.map(att =>
            att.id === attendeeToRSVPId ? { ...att, rsvp: status } : att
        );

        const enrichedAttendees = updatedAttendees.sort((a, b) => {
            // Admins first
            // Sorting priority: admin → attendee/guest → planner → fallback
            const roleOrder = { admin: 0, attendee: 1, guest: 1, partial: 1, planner: 2 };
            const roleA = roleOrder[a.role] ?? 99;
            const roleB = roleOrder[b.role] ?? 99;

            if (roleA !== roleB) return roleA - roleB;

            return a.lname.toLowerCase().localeCompare(b.lname.toLowerCase());
        });

        setSortedAttendees(enrichedAttendees);

        //now update the Planning
        set_PA_GlobalObject(prev => ({
            ...prev,
            Planning: {
                ...prev.Planning,
                attendees: enrichedAttendees
            }
        }));

        // Server Update
        if (PA_GlobalObject.Planning.status !== 10) {
            sendSocketMessage({
                action: "E_updateAttendeeRsvpStatus",
                event_id: PA_GlobalObject.Planning.id,
                attendee_id: attendeeToRSVPId,
                rsvp: status
            });
        }
    }

    function handlePromptChangeClose() {
        props.setShowEventItemConfig(false);

        setAnchorAttendeeListMenu(null);
    }

    const [attendeeBudgetDialogOpen, setAttendeeBudgetDialogOpen] = useState(false);

    // Handle opening and closing the dialog
    const handleChipClick = (attendee_id) => {
        setAttendeeBudgetDialogOpen(true);
    };


    const [openWelcomeDialog, setOpenWelcomeDialog] = useState(false);
    const [targetAttendee, setTargetAttendee] = useState(null);
    const [welcomeMessage, setWelcomeMessage] = useState("");

    const handleSendQuickRSVP = (attendee) => {
        if (PA_GlobalObject.Planning.status !== 10) {

            sendSocketMessage({
                action: "E_sendAttendeeRSVPRequest", // Ensure your backend has this action
                event_id: PA_GlobalObject.Planning.id,
                attendee_id: attendee.id
            });
        }
    };

    const handleSendWelcomeEmail = () => {

        if (PA_GlobalObject.Planning.status !== 10) {

            if (!targetAttendee) return;

            sendSocketMessage({
                action: "E_sendAttendeeWelcomeEmail", // Ensure your backend has this action
                event_id: PA_GlobalObject.Planning.id,
                attendee_id: targetAttendee.id,
                message: welcomeMessage
            });

            setOpenWelcomeDialog(false);
        }

    };

    /*
        for adding the Event/details to the Attendee Google or other Calendar
     */
    const [calendarModalOpen, setCalendarModalOpen] = useState(false);
    const [calendarEvents, setCalendarEvents] = useState([]);
    const handleOpenCalendarExport = () => {
        const generated = generateGoogleCalendarEvents(); // function you'll write next
        setCalendarEvents(generated);
        setCalendarModalOpen(true);
    };

    function handleAddToCalendar(attendee) {
        const eventTitle = encodeURIComponent(PA_GlobalObject.Planning.title); // Customize or pull from event data
        const location = encodeURIComponent("Event Location");
        const details = encodeURIComponent(`Hi ${Account.fname},\n\nYou're invited!`);

        // Use event start/end datetimes in ISO format
        const startDate = dayjs(eventHasDates?PA_GlobalObject.Planning.time_table.dates[0].date : '').utc().format("YYYYMMDDTHHmmss[Z]");
        const endDate = dayjs(eventHasDates?PA_GlobalObject.Planning.time_table.dates[PA_GlobalObject.Planning.time_table.dates.length -1 ].date : '').utc().format("YYYYMMDDTHHmmss[Z]");

        const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDate}/${endDate}&details=${details}&location=${location}&sf=true&output=xml`;

        window.open(calendarUrl, "_blank");
    }

    function handleDownloadICSWithDetails() {

        const eventItems = [];

        const addEvent = ({ title, start, end, location, description }) => {
            const uid = `event-${PA_GlobalObject.Planning.id}@plannedadventure.com`;
            eventItems.push(`BEGIN:VEVENT
                UID:${uid}
                SUMMARY:${title}
                DTSTART;TZID=UTC:${start}
                DTEND;TZID=UTC:${end}
                DESCRIPTION:${description}
                LOCATION:${location}
                STATUS:CONFIRMED
                SEQUENCE:0
                BEGIN:VALARM
                TRIGGER:-PT15M
                ACTION:DISPLAY
                DESCRIPTION:Reminder
                END:VALARM
                END:VEVENT`
            );
        };

        //the overall event
        addEvent({
            title: PA_GlobalObject.Planning.title,
            start: PA_GlobalObject.Planning.time_table.dates[0].date,
            end: PA_GlobalObject.Planning.time_table.dates[PA_GlobalObject.Planning.time_table.dates.length - 1].date,
            location: '',
            description: ''
        });

        /*
            ONLY get things that this Attendee is in
         */

        // Lodging
        PA_GlobalObject.Planning.lodging
            .filter((_lodging) => _lodging.attendees.some(_att => _att.id === Account.id))
            .forEach(item => {
                if (!item.time_table?.dates?.[0]) return;

                const startDateObj = item.time_table?.dates?.[0];
                const startDate = startDateObj?.date;
                const beginTime = startDateObj?.checkin_time;
                const endDateObj = item.time_table.dates[item.time_table.dates.length-1];
                const endDate = endDateObj?.date;
                const endTime = endDateObj?.checkout_time;

                const beginDateTime = dayjs(`${startDate} ${beginTime}`, 'YYYY-MM-DD h:mm A');
                const endDateTime = endTime
                        ? dayjs(`${endDate} ${endTime}`, 'YYYY-MM-DD h:mm A')
                        : beginDateTime.add(1, 'day');

                addEvent({
                title: `🏨 Lodging: ${item.name}`,
                start: beginDateTime.format('YYYYMMDDTHHmmss'),
                end: endDateTime.format('YYYYMMDDTHHmmss'),
                location: item.location?.formatted_address,
                description: item.notes
            });
        });

        // Meals
        PA_GlobalObject.Planning.meals
            .filter((_meal) => _meal.attendees.some(_att => _att.id === Account.id))
            .forEach(item => {
                const dateObj = item.time_table?.dates?.[0];
                const date = dateObj?.date;
                const beginTime = dateObj?.begin_time;
                const endTime = dateObj?.end_time;
                if (!date || !beginTime) return;

                const beginDateTime = dayjs(`${date} ${beginTime}`, 'YYYY-MM-DD h:mm A');
                const endDateTime = endTime
                    ? dayjs(`${date} ${endTime}`, 'YYYY-MM-DD h:mm A')
                    : beginDateTime.add(1, 'hour');

                addEvent({
                    title: `🍽️ Meal: ${item.location?.name || item.name}`,
                    start: beginDateTime.format('YYYYMMDDTHHmmss'),
                    end: endDateTime.format('YYYYMMDDTHHmmss'),
                    location: item.location?.formatted_address,
                    description: item.notes
                });
        });

        // Activities
        PA_GlobalObject.Planning.activities
            .filter((_activity) => _activity.attendees.some(_att => _att.id === Account.id))
            .forEach(item => {
                const dateEntries = item.time_table?.dates;
                if (!Array.isArray(dateEntries) || dateEntries.length === 0) return;

                const beginDate = dateEntries[0].date;
                const beginTime = dateEntries[0].begin_time;
                const endDate = dateEntries[dateEntries.length - 1]?.date || beginDate;
                const endTime = dateEntries[dateEntries.length - 1]?.end_time;

                if (!beginDate || !beginTime) return;

                // Format using dayjs (adjust format if using 24-hour time)
                const beginDateTime = dayjs(`${beginDate} ${beginTime}`, 'YYYY-MM-DD h:mm A');
                const endDateTime = endTime
                    ? dayjs(`${endDate} ${endTime}`, 'YYYY-MM-DD h:mm A')
                    : beginDateTime.add(1, 'hour'); // fallback if no endTime

                addEvent({
                    title: `🎉 Activity: ${item.title}`,
                    start: beginDateTime.toISOString(),
                    end: endDateTime.toISOString(),
                    location: item.location?.formatted_address,
                    description: item.notes
                });
            });


        const icsContent = `BEGIN:VCALENDAR
            VERSION:2.0
            CALSCALE:GREGORIAN
            METHOD:PUBLISH
            ${eventItems.join('\n')}
            END:VCALENDAR`;

        const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "event-details.ics";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function generateGoogleCalendarEvents() {
        const calendarEvents = [];

        const createEventLink = ({ title, start, end, location, description }) => {
            const baseUrl = "https://calendar.google.com/calendar/render?action=TEMPLATE";
            const params = new URLSearchParams({
                text: title,
                dates: `${start}/${end}`,
                details: description || '',
                location: location || '',
            });
            return `${baseUrl}&${params.toString()}`;
        };

        const formatLabel = (startObj, endObj) => {
            // 1. Format the basic start date and time
            const startDateLabel = startObj.format("ddd, MMM D"); // e.g., "Thu, Nov 13"
            const startTimeLabel = startObj.format("h:mm A");     // e.g., "9:15 AM"

            // If there is no end object (or it's null/undefined), return only the start date/time.
            if (!endObj) {
                return `${startDateLabel}, ${startTimeLabel}`;
            }

            // 2. Format the end date and time
            const endDateLabel = endObj.format("ddd, MMM D");
            const endTimeLabel = endObj.format("h:mm A");

            // 3. Compare the dates (using Day.js isSame to compare dates only)
            const isSameDate = startObj.isSame(endObj, 'day');

            if (isSameDate) {
                // If the dates are the same: Show start date + start time - end time
                // e.g., "Thu, Nov 13, 9:15 AM - 10:15 AM"
                return `${startDateLabel}, ${startTimeLabel} - ${endTimeLabel}`;
            } else {
                // If the dates are different: Show full start date/time to full end date/time
                // e.g., "Thu, Nov 13, 9:15 AM - Fri, Nov 14, 10:15 AM"
                return `${startDateLabel}, ${startTimeLabel} - ${endDateLabel}, ${endTimeLabel}`;
            }
        };

        const addEvent = ({ category, title, startObj, endObj, location, description }) => {
            calendarEvents.push({
                category,
                title,
                start: startObj.utc().format("YYYYMMDDTHHmmss[Z]"),
                end: endObj.utc().format("YYYYMMDDTHHmmss[Z]"),
                link: createEventLink({
                    title,
                    start: startObj.utc().format("YYYYMMDDTHHmmss[Z]"),
                    end: endObj.utc().format("YYYYMMDDTHHmmss[Z]"),
                    location,
                    description,
                }),
                location,
                dateLabel: formatLabel(startObj, endObj),
            });
        };

        const planning = PA_GlobalObject.Planning;
        const eventStart = dayjs(`${planning.time_table.dates[0].date}T00:00`);
        const eventEnd = dayjs(`${planning.time_table.dates.at(-1).date}T23:59`);

        addEvent({
            category: 'event',
            title: planning.title,
            startObj: eventStart,
            endObj: eventEnd,
            location: '',
            description: ''
        });

        planning.lodging
            .filter(l => l.attendees?.some(a => a.id === Account.id))
            .forEach(item => {
                const startDateObj = item.time_table?.dates?.[0];
                const startDate = startDateObj?.date;
                const beginTime = startDateObj?.checkin_time;
                const endDateObj = item.time_table.dates[item.time_table.dates.length-1];
                const endDate = endDateObj?.date;
                const endTime = endDateObj?.checkout_time;

                const beginDateTime = dayjs(`${startDate} ${beginTime}`, 'YYYY-MM-DD h:mm A');
                const endDateTime = endTime
                    ? dayjs(`${endDate} ${endTime}`, 'YYYY-MM-DD h:mm A')
                    : beginDateTime.add(1, 'day');

                addEvent({
                    category: 'lodging',
                    title: `🏨 Lodging: ${item.name}`,
                    startObj: beginDateTime,
                    endObj: endDateTime,
                    location: item.location?.formatted_address,
                    description: item.notes
                });
            });

        planning.meals
            .filter(m => m.attendees?.some(a => a.id === Account.id))
            .forEach(item => {
                const dateObj = item.time_table?.dates?.[0];
                if (!dateObj?.date || !dateObj?.begin_time) return;
                const start = dayjs(`${dateObj.date} ${dateObj.begin_time}`, 'YYYY-MM-DD h:mm A');
                const end = dateObj.end_time
                    ? dayjs(`${dateObj.date} ${dateObj.end_time}`, 'YYYY-MM-DD h:mm A')
                    : start.add(1, 'hour');

                addEvent({
                    category: 'meals',
                    title: `🍽️ Meal: ${item.location?.name || item.name}`,
                    startObj: start,
                    endObj: end,
                    location: item.location?.formatted_address,
                    description: item.notes
                });
            });

        planning.activities
            .filter(a => a.attendees?.some(p => p.id === Account.id))
            .forEach(item => {
                const dates = item.time_table?.dates;
                if (!Array.isArray(dates) || !dates[0]) return;
                const start = dayjs(`${dates[0].date} ${dates[0].begin_time}`, 'YYYY-MM-DD h:mm A');
                const endDate = dates.at(-1).date || dates[0].date;
                const endTime = dates.at(-1).end_time;
                const end = endTime
                    ? dayjs(`${endDate} ${endTime}`, 'YYYY-MM-DD h:mm A')
                    : start.add(1, 'hour');

                addEvent({
                    category: 'activities',
                    title: `🎉 Activity: ${item.title}`,
                    startObj: start,
                    endObj: end,
                    location: item.location?.formatted_address,
                    description: item.notes
                });
            });

        return calendarEvents;
    }




    return (

        <div className="attendee-list-container" >

            {/* --- ATTENDEES HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* Title Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #ec4899 0%, #d946ef 100%)', // Rose/Pink gradient for people
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(236, 72, 153, 0.3)'
                        }}>
                            <i className="icon-group" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4, whiteSpace: 'nowrap' }}>
                                Attendees
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <i className="icon-check-circle" style={{ color: '#ec4899', fontSize: '10px' }} />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 0.1, whiteSpace: 'nowrap' }}>
                                    Guest Management
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Controls Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>

                        {/* Info Icon */}
                        <Tooltip title="Attendee Info">
                            <IconButton
                                onClick={() => setAttendeeInfoDialogOpen(!isAttendeeInfoDialogOpen)}
                                sx={{ color: '#64748b' }}
                            >
                                <i className="icon-info-circle" style={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>

                        {/* Menu Add Button */}
                        {/* Menu Add Button */}
                        <Tooltip title="Add Attendees">
                            <IconButton
                                onClick={() => setAddAttendeesDialogOpen(true)}
                                sx={{
                                    ml: 0.5,
                                    bgcolor: '#1e293b',
                                    color: 'white',
                                    borderRadius: '12px',
                                    width: '38px',
                                    height: '38px',
                                    boxShadow: '0 4px 12px rgba(30, 41, 59, 0.25)',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        bgcolor: '#334155',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 6px 16px rgba(30, 41, 59, 0.3)',
                                    },
                                    '&:active': { transform: 'translateY(0px)' }
                                }}
                            >
                                <i className="icon-plus" style={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>

                        {/* Attendees Action Menu */}
                        <Menu
                            anchorEl={anchorAttendeeListMenu}
                            open={Boolean(anchorAttendeeListMenu)}
                            onClose={handleAttendeeListMenuClose}
                            PaperProps={{
                                sx: {
                                    borderRadius: '12px',
                                    mt: 1,
                                    minWidth: 240,
                                    boxShadow: '0px 10px 25px rgba(0,0,0,0.2)',
                                }
                            }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                            <MenuItem
                                data-id="from-previous"
                                onClick={handleAttendeeListMenuClick}
                                disabled={!authenticated || attendeesReferenceArray.length === 0}
                                sx={{ gap: 1.5, py: 1.2 }}
                            >
                                <i className="icon-history" style={{ color: '#6366f1' }} />
                                <ListItemText primary="From Previous" primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }} />
                                <Typography variant="caption" sx={{ fontWeight: 700, color: '#94a3b8' }}>
                                    {attendeesReferenceArray.length > 0 ? attendeesReferenceArray.length : ''}
                                </Typography>
                                {!authenticated && <i className="icon-lock2" style={{ fontSize: '14px', color: '#94a3b8' }} />}
                            </MenuItem>

                            <MenuItem
                                data-id="new-entry"
                                onClick={handleAttendeeListMenuClick}
                                disabled={!authenticated}
                                sx={{ gap: 1.5, py: 1.2 }}
                            >
                                <i className="icon-user-plus" style={{ color: '#22c55e' }} />
                                <ListItemText primary="New Entry" primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }} />
                                {!authenticated && <i className="icon-lock2" style={{ fontSize: '14px', color: '#94a3b8' }} />}
                            </MenuItem>

                            <Divider sx={{ my: 0.5, opacity: 0.6 }} />

                            <MenuItem
                                data-id="sample-attendees"
                                onClick={handleAttendeeListMenuClick}
                                sx={{ gap: 1.5, py: 1.2 }}
                            >
                                <i className="icon-users" style={{ color: '#f59e0b' }} />
                                <ListItemText primary="Sample Attendees" primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }} />
                                <Typography variant="caption" sx={{ fontWeight: 700, color: '#94a3b8' }}>
                                    {sample_attendees.length}
                                </Typography>
                            </MenuItem>

                            <MenuItem
                                data-id="attendees-dialog"
                                onClick={handleAttendeeListMenuClick}
                                sx={{ gap: 1.5, py: 1.2 }}
                            >
                                <i className="icon-address-book" style={{ color: '#64748b' }} />
                                <ListItemText primary="Attendee Dialog" primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }} />
                            </MenuItem>
                        </Menu>
                    </Box>
                </Box>
            </Paper>


            {/* show the list of attendees */}
            <div
                className={
                    props.showingPageHeader
                        ? "attendee-list-items-container with-header"
                        : "attendee-list-items-container"
                }
            >

                    {sortedAttendees.length > 0 ? (
                        sortedAttendees.map((attendee, index) => {
                            // Dynamic styling based on Role
                            const isHost = PA_GlobalObject?.Planning?.host?.includes(attendee.id);
                            const isPlanner = attendee.role === 'planner';
                            const isPartial = attendee.role === 'partial';

                            const cardBg = isHost ? '#fcf9dd' : isPlanner ? '#e8f2ed' : '#fff';
                            const borderColor = isHost ? '#f09637' : isPlanner ? '#2e7d32' : '#ddd';

                            return (
                                <Card
                                    key={attendee.id} // Use ID, not Index, for sorted lists
                                    sx={{
                                        position: 'relative',
                                        display: 'flex',
                                        borderRadius: '8px',
                                        border: `1px solid ${borderColor}`,
                                        backgroundColor: cardBg,
                                        overflow: 'hidden',
                                        marginBottom: '12px',
                                        boxShadow: isHost ? 2 : 1
                                    }}
                                >
                                    {/* LEFT - Avatar Section */}
                                    <Box
                                        sx={{
                                            width: '80px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: isHost ? '#fff9c4' : isPlanner ? '#c8e6c9' : '#fafafa',
                                            borderRight: `1px solid ${borderColor}44`
                                        }}
                                    >
                                        {attendee.isSample ? (
                                            <Chip
                                                label="SAMPLE"
                                                size="small"
                                                sx={{
                                                    bgcolor: "#607d8b",
                                                    color: "#fff",
                                                    fontWeight: "bold",
                                                    fontSize: "10px",
                                                    height: "18px",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                        ) : (
                                            <Avatar
                                                src={attendee.avatar?.preview || ""}
                                                {...(!attendee.avatar?.preview && stringAvatar(`${attendee.fname} ${attendee.lname}`))}
                                                sx={{
                                                    width: 50,
                                                    height: 50,
                                                    border: `2px solid ${isHost ? '#f09637' : '#fff'}`,
                                                    ...(attendee.avatar?.preview ? {} : {
                                                        fontSize: '16px',
                                                        backgroundColor: stringToColor(`${attendee.fname} ${attendee.lname}`)
                                                    })
                                                }}
                                            />
                                        )}
                                        {isHost && <i className="icon-crown" style={{ color: '#f09637', marginTop: '5px', fontSize: '14px' }} />}
                                    </Box>

                                    {/* RIGHT - Info and Actions */}
                                    <Box sx={{ flex: 1, padding: '10px', display: 'flex', flexDirection: 'column' }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <Box sx={{ overflow: 'hidden' }}>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                                    {attendee.lname.toUpperCase()}, {attendee.fname.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    sx={{
                                                        display: "block",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow: "ellipsis",
                                                    }}
                                                >
                                                    {attendee.email || "No email provided"}
                                                </Typography>
                                            </Box>

                                            {/* ONLY SHOW MENU IF USER IS THE ATTENDEE OR IF THE USER IS A HOST */}
                                            {(() => {
                                                // 1. Identify the user's relationship to this specific card
                                                const isSelf = Account.id === attendee.id;
                                                const isHost = PA_GlobalObject.Planning.host.includes(Account.id);

                                                // 2. Safely check if the current user is a Planner
                                                const currentUser = PA_GlobalObject.Planning.attendees.find(att => att.id === Account.id);
                                                const isPlanner = currentUser?.role === "planner";

                                                // 3. Permission Gate: If none of these are true, don't even render the button
                                                if (!isSelf && !isHost && !isPlanner) return null;

                                                return (
                                                    <div>
                                                        <IconButton
                                                            size="small"
                                                            onClick={(event) => handleOpenAttendeeMenu(event, index)}
                                                        >
                                                            <i className="icon-menu2" style={{ fontSize: '18px' }} />
                                                        </IconButton>

                                                        <Menu
                                                            anchorEl={anchorAttendeeElements[index]}
                                                            open={Boolean(anchorAttendeeElements[index])}
                                                            onClose={() => handleCloseAttendeeMenu(index)}
                                                            PaperProps={{ sx: { width: '300px', borderRadius: '8px' } }}
                                                        >
                                                            {/* EDIT SECTION (Hide for samples) */}
                                                            {!attendee.isSample && (
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        handleCloseAttendeeMenu(index);
                                                                        handleDialogEditOpen(attendee.id);
                                                                    }}
                                                                    sx={{ py: 1.5 }}
                                                                >
                                                                    <i className="icon-pencil" style={{ marginRight: '10px', color: '#666' }} />
                                                                    <Typography variant="body2">
                                                                        Edit <strong>{attendee.fname.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())} {attendee.lname.toUpperCase()}</strong>
                                                                    </Typography>
                                                                </MenuItem>
                                                            )}

                                                            {/* ROLE PERMISSIONS (Visible to Hosts and Planners) */}
                                                            {(isHost || isPlanner) && [
                                                                <Divider key="role-div" />,
                                                                <ListSubheader key="role-header" sx={{ lineHeight: '24px', fontWeight: 800 }}>ROLE PERMISSIONS</ListSubheader>,
                                                                ...[
                                                                    { role: 'admin', label: 'Event Host', desc: 'Full administrative control.' },
                                                                    { role: 'guest', label: 'Standard Attendee', desc: 'Can see public info and own items.' },
                                                                    { role: 'partial', label: 'Partial Attendee', desc: 'Limited visibility.' },
                                                                    { role: 'planner', label: 'Event Planner', desc: 'Hidden from lists.' }
                                                                ].map((r) => {
                                                                    const isActive = attendee.role === r.role || (r.role === 'admin' && attendee.role === 'master_admin');
                                                                    return (
                                                                        <MenuItem
                                                                            key={r.role}
                                                                            onClick={() => handleUpdateAttendeeRole(index, attendee.id, r.role)}
                                                                            sx={{ py: 1 }}
                                                                        >
                                                                            <Box>
                                                                                <Typography variant="body2" sx={{ fontWeight: isActive ? 700 : 400 }}>
                                                                                    {r.label} {isActive && <i className="icon-check" style={{ color: 'green', marginLeft: '5px' }} />}
                                                                                </Typography>
                                                                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                                                    {r.desc}
                                                                                </Typography>
                                                                            </Box>
                                                                        </MenuItem>
                                                                    );
                                                                })
                                                            ]}

                                                            {/* COMMUNICATIONS (Visible to Hosts, Planners, and self) */}
                                                            {(isHost || isPlanner || isSelf) && [
                                                                <Divider key="comm-div" />,
                                                                <ListSubheader key="comm-header" sx={{ lineHeight: '24px', fontWeight: 800 }}>COMMUNICATIONS</ListSubheader>,
                                                                <Tooltip key="rsvp-tool" title={!attendee.email ? "Add email to send" : ""} placement="left" arrow>
                                                                    <span>
                                                                        <MenuItem disabled={!attendee.email} onClick={() => { handleCloseAttendeeMenu(index); handleSendQuickRSVP(attendee); }}>
                                                                            <i className="icon-envelope" style={{ marginRight: '10px', color: !attendee.email ? '#ccc' : '#1565c0' }} />
                                                                            <Typography variant="body2">Send RSVP Request</Typography>
                                                                        </MenuItem>
                                                                    </span>
                                                                </Tooltip>,
                                                                <Tooltip key="welcome-tool" title={!attendee.email ? "Add email to send" : ""} placement="left" arrow>
                                                                    <span>
                                                                        <MenuItem disabled={!attendee.email} onClick={() => { handleCloseAttendeeMenu(index); setTargetAttendee(attendee); setWelcomeMessage(`Hi ${attendee.fname}!`); setOpenWelcomeDialog(true); }}>
                                                                            <i className="icon-paper-plane" style={{ marginRight: '10px', color: !attendee.email ? '#ccc' : '#2e7d32' }} />
                                                                            <Typography variant="body2">Send Welcome Email...</Typography>
                                                                        </MenuItem>
                                                                    </span>
                                                                </Tooltip>
                                                            ]}

                                                            {/* CALENDAR SECTION (Only for OWN profile) */}
                                                            {isSelf && [
                                                                <Divider key="cal-div" />,
                                                                <ListSubheader key="cal-header" sx={{ lineHeight: '24px', fontWeight: 800, mt: 1 }}>YOUR CALENDAR</ListSubheader>,
                                                                <MenuItem key="google-cal" onClick={() => { handleCloseAttendeeMenu(index); handleOpenCalendarExport(); }} sx={{ py: 1 }}>
                                                                    <i className="icon-calendar" style={{ marginRight: '10px', color: '#1565c0', fontSize: '18px' }} />
                                                                    <Typography variant="body2">Add to Google Calendar</Typography>
                                                                </MenuItem>,
                                                                <MenuItem key="ics-cal" onClick={() => { handleCloseAttendeeMenu(index); handleDownloadICSWithDetails(); }} sx={{ py: 1 }}>
                                                                    <i className="icon-download" style={{ marginRight: '10px', color: '#1565c0', fontSize: '18px' }} />
                                                                    <Typography variant="body2">Download .ICS File</Typography>
                                                                </MenuItem>
                                                            ]}

                                                            {/* DELETE SECTION (Hosts/Planners, but can't delete themselves) */}
                                                            {(isHost || isPlanner) && !isSelf && (
                                                                <Box>
                                                                    <Divider />
                                                                    <MenuItem onClick={() => handleDialogDeleteOpen(index, attendee.id)} sx={{ color: 'error.main' }}>
                                                                        <i className="icon-trash" style={{ marginRight: '10px' }} /> Delete Attendee
                                                                    </MenuItem>
                                                                </Box>
                                                            )}
                                                        </Menu>
                                                    </div>
                                                );
                                            })()}
                                        </Box>

                                        {/* Bottom: Status Chips */}
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mt: 'auto', pt: 1 }}>
                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                {!isPlanner && (
                                                    <Chip
                                                        label={attendee.rsvp === 'yes' ? 'Attending' : attendee.rsvp === 'decline' ? 'Declined' : 'RSVP Pending'}
                                                        size="small"
                                                        onClick={() => handleDialogRSVPOpen(attendee.id)}
                                                        sx={{
                                                            fontSize: '10px',
                                                            height: '22px',
                                                            cursor: 'pointer',
                                                            bgcolor: attendee.rsvp === 'yes' ? '#c8e6c9' : attendee.rsvp === 'decline' ? '#ffcdd2' : '#e3f2fd',
                                                            color: attendee.rsvp === 'yes' ? '#2e7d32' : attendee.rsvp === 'decline' ? '#c62828' : '#1565c0',
                                                            '&:hover': { opacity: 0.8 }
                                                        }}
                                                    />
                                                )}
                                                {isPartial && <Chip label="Partial" size="small" sx={{ height: '18px', fontSize: '9px', bgcolor: '#eee' }} />}
                                            </Box>

                                            {/* Indicators */}
                                            <Box sx={{ display: 'flex', gap: 1, opacity: 0.6 }}>
                                                {attendee.push_notifications && <i className="icon-bell-ringing2" style={{ fontSize: '14px' }} />}
                                                {isPlanner && <i className="icon-compass" style={{ fontSize: '14px' }} />}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Card>
                            );
                        })
                    ) : (
                            <Grid item>
                                <Paper elevation={2} sx={{margin: '20px'}}>
                                    <Card>
                                        <CardMedia
                                            sx={{ height: 140 }}
                                            image={attendeesHeaderImage}
                                            title="Add Attendees"
                                        />
                                        <CardContent>
                                            <Typography gutterBottom variant="h7" component="div">
                                                Adding Attendees could be the most important thing!
                                            </Typography>
                                            <Typography gutterBottom variant="body2" color="text.secondary">
                                                There are several ways to easily add Attendees:
                                            </Typography>
                                            <Typography gutterBottom variant="body2" color="text.secondary">
                                                1. <strong>From previous Events</strong>. All of the Attendees from
                                                previous Events will be available for you
                                                to choose from.
                                            </Typography>
                                            <Typography gutterBottom variant="body2" color="text.secondary">
                                                2. <strong>Enter manually</strong>. As you start to build your
                                                Events portfolio, easily add just some basic
                                                information to get them fully engaged.
                                            </Typography>
                                            <Typography gutterBottom variant="body2" color="text.secondary">
                                                3. <strong>Android phone and Chrome</strong>. Select Attendees right from
                                                your Contacts to add.
                                            </Typography>
                                            <Typography gutterBottom variant="body2" color="text.secondary">
                                                4. <strong>Bulk upload</strong>. If you've got a spreadsheet or list
                                                of Contacts you can use that to make things super
                                                simple and quick.
                                            </Typography>
                                            <Typography gutterBottom variant="body2" color="text.secondary">
                                                5. <strong>Samples</strong>. You can get started planning quick if
                                                you just want to use some of our sample Attendees too.
                                            </Typography>
                                        </CardContent>
                                    </Card>

                                </Paper>
                            </Grid>
                        )
                    }


                <CalendarExportDialog
                    open={calendarModalOpen}
                    onClose={() => setCalendarModalOpen(false)}
                    calendarEvents={calendarEvents}
                />

                {/* Add Event Attendees Dialog */}
                <AttendeesAddDialog
                    isOpen={isAddAttendeesDialogOpen}
                    onClose={() => setAddAttendeesDialogOpen(false)}
                />

                <Dialog
                    open={openDialogEventAdmin}
                    onClose={handleDialogEventAdminClose}
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Before we can remove Planner status for <strong>{attendeeToRemovePlannerStatusName}</strong> there needs to be another attendee assigned as Planner.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogEventAdminClose} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openDialogDelete}
                    onClose={handleDialogDeleteClose}
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete {attendeeToDeleteName}?
                        </DialogContentText>
                        <DialogContentText id="alert-dialog-description" sx={{ fontWeight: "bold", color: "red" }}>
                            Important: This will remove {attendeeToDeleteName} from all event-related plans,
                            including meals, lodging, etc. and any shared costs. Any split balances will be recalculated.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogDeleteClose}>Cancel</Button>
                        <Button onClick={handleDialogDeleteOK} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openWelcomeDialog}
                    onClose={() => setOpenWelcomeDialog(false)}
                    PaperProps={{ sx: { borderRadius: '12px', width: '450px' } }}
                >
                    <DialogTitle sx={{ fontWeight: 800 }}>Send Welcome Email</DialogTitle>
                    <DialogContent>
                        <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                            Recipient: <b>{targetAttendee?.fname} {targetAttendee?.lname}</b>
                        </Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            label="Personal Message (Optional)"
                            value={welcomeMessage}
                            onChange={(e) => setWelcomeMessage(e.target.value)}
                            placeholder="Type a personal note here..."
                        />
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={() => setOpenWelcomeDialog(false)} color="inherit">Cancel</Button>
                        <Button
                            variant="contained"
                            onClick={handleSendWelcomeEmail}
                            sx={{ borderRadius: '8px', bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' } }}
                        >
                            Send Now
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openDialogRSVP}
                    onClose={handleDialogRSVPClose}
                    PaperProps={{
                        sx: {
                            borderRadius: '16px',
                            padding: '10px',
                            maxWidth: '400px',
                            width: '100%'
                        }
                    }}
                >
                    <DialogTitle sx={{ textAlign: 'center', fontWeight: 800, fontSize: '1.25rem', pb: 1 }}>
                        Update RSVP Status
                    </DialogTitle>

                    <DialogContent>
                        <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
                            Is this attendee joining the adventure?
                        </Typography>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1.5
                        }}>
                            {/* YES OPTION */}
                            <Button
                                fullWidth
                                variant="outlined"
                                startIcon={<i className="icon-check" style={{ fontSize: '20px' }} />}
                                onClick={() => handleDialogRSVPOK('yes')}
                                sx={{
                                    justifyContent: 'flex-start',
                                    py: 1.5,
                                    px: 3,
                                    borderRadius: '12px',
                                    borderColor: '#e8f2ed',
                                    backgroundColor: '#f1f8f5',
                                    color: '#2e7d32',
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    fontWeight: 700,
                                    transition: '0.2s',
                                    '&:hover': {
                                        backgroundColor: '#2e7d32',
                                        color: '#fff',
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            >
                                Count them in!
                            </Button>

                            {/* DECLINE OPTION */}
                            <Button
                                fullWidth
                                variant="outlined"
                                startIcon={<i className="icon-cross" style={{ fontSize: '20px' }} />}
                                onClick={() => handleDialogRSVPOK('decline')}
                                sx={{
                                    justifyContent: 'flex-start',
                                    py: 1.5,
                                    px: 3,
                                    borderRadius: '12px',
                                    borderColor: '#ffebee',
                                    backgroundColor: '#fff5f5',
                                    color: '#c62828',
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    fontWeight: 700,
                                    transition: '0.2s',
                                    '&:hover': {
                                        backgroundColor: '#c62828',
                                        color: '#fff',
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            >
                                They can't make it
                            </Button>

                            {/* PENDING / NA OPTION */}
                            <Button
                                fullWidth
                                variant="outlined"
                                startIcon={<i className="icon-clock" style={{ fontSize: '20px' }} />}
                                onClick={() => handleDialogRSVPOK('na')}
                                sx={{
                                    justifyContent: 'flex-start',
                                    py: 1.5,
                                    px: 3,
                                    borderRadius: '12px',
                                    borderColor: '#e3f2fd',
                                    backgroundColor: '#f0f7ff',
                                    color: '#1565c0',
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    fontWeight: 700,
                                    transition: '0.2s',
                                    '&:hover': {
                                        backgroundColor: '#1565c0',
                                        color: '#fff',
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            >
                                Wait / Set to Pending
                            </Button>
                        </Box>
                    </DialogContent>

                    <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                        <Button
                            onClick={handleDialogRSVPClose}
                            sx={{ color: 'text.secondary', textTransform: 'none', fontWeight: 600 }}
                        >
                            Nevermind
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog for setting the attendee budget and preferred currency */}
                <PersonalBudget
                    isOpen={attendeeBudgetDialogOpen}
                    onClose={() => setAttendeeBudgetDialogOpen(false)}
                />

                <InfoAttendees
                    isOpen={isAttendeeInfoDialogOpen}
                    onClose={() => setAttendeeInfoDialogOpen(false)}
                />

            </div>

        </div>

    )
}

export default AttendeesList;
